import Cleave from 'cleave.js';

export default function createCleaveTransformer(cleaveOptions: ConstructorParameters<typeof Cleave>[1]) {
  const stubInputElement = document.createElement('input');
  const instance = new Cleave(stubInputElement, {
    ...cleaveOptions,
    // Otherwise we can't clear e.g. inputs with backspace, as it would always replace `22.03` with `22.03.`
    delimiterLazyShow: true,
  });
  instance.destroy();
  return (toTransform: string) => {
    instance.setRawValue(toTransform);
    return stubInputElement.value;
  };
}
